"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomMessageReactionsSet = void 0;
var _constants = require("../constants");
var _streamChatReact = require("stream-chat-react");
var useCustomMessageReactionsSet = function useCustomMessageReactionsSet() {
  var _useMessageContext = (0, _streamChatReact.useMessageContext)(),
    message = _useMessageContext.message;
  var messageHasNewEmojiSet = message.created_at > _constants.CHAT_REACTIONS_TRANSITION_DATE;
  return {
    messageHasNewEmojiSet: messageHasNewEmojiSet,
    options: messageHasNewEmojiSet ? _constants.GROUP_CHAT_CUSTOM_REACTIONS : undefined
  };
};
exports.useCustomMessageReactionsSet = useCustomMessageReactionsSet;